module.exports = require("electron");


//////////////////
// WEBPACK FOOTER
// external "require(\"electron\")"
// module id = electron
// module chunks = 0